module.exports = __webpack_public_path__ + "static/image 101-eccbff088b4ff31c3d06af967e953c44.png";